import { API } from '../helpers/API';
import { EmbedTokenResponse } from '../interfaces/PowerBi';
import { IPowerBiService } from './Interfaces/IPowerBIService';

export class PowerBiService implements IPowerBiService {
  private baseController = '/PowerBiSdk';
  public async GetEmbedToken(reportCode: string, userInteracted: boolean): Promise<EmbedTokenResponse> {
    return (
      await API.GetAsync<EmbedTokenResponse>(
        `${this.baseController}/embedToken/${reportCode}?userInteracted=${userInteracted}`
      )
    ).data;
  }
  public async GetCapacityStatus(): Promise<string> {
    return (
      await API.GetAsync<string>(
        `${this.baseController}/capacity`
      )
    ).data;
  }
  public async StartCapacity(): Promise<void> {
    await API.PostAsync<any>(`${this.baseController}/capacity`, {});
  }
}